import React, { useEffect, useState } from "react";
// ...existing imports...
import { useDispatch, useSelector } from "react-redux";
import AddFinalProduct from "./add_products";
import { fetchRawCategories } from "../../../slices/company/rawCategorySlice";
import { fetchBrands } from "../../../slices/company/brandSlice";
import { createProduct, getProducts, updateProduct } from "../../../slices/company/rawProductSlice";
import { addFinalProduct, deleteFinalProduct, fetchFinalProducts, updateFinalProduct, updateProductVariation, moveToLoose, transferStock, addDirectStock } from "../../../slices/company/finalProductSlice";
import { fetchUnits } from "../../../slices/company/unitsSlice";
import { Delete, Pen, Eye, Download, Printer, PrinterCheck, ReceiptText, Search, Airplay, Activity, ArrowLeftRight, Plus } from "lucide-react";
import DataTable from 'react-data-table-component';
import { API_URL } from "../../../utils/constant";
import Swal from "sweetalert2";
import { fetchCategories } from "../../../slices/company/finalCategorySlice";
import Modal from '../../../components/modal';
import { customTableStyles } from "../../../utils/tableStylings";
import AddPurchases from "../purchases/add_purchases";
import { useNavigate } from "react-router-dom";

const Products = () => {
    // Tag input for serial numbers
    const [serialTags, setSerialTags] = useState([]);
    const navigate = useNavigate();

    // Add serial tag and select row
    const handleSerialTagInput = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            const value = e.target.value.trim();
            if (value && !serialTags.includes(value)) {
                setSerialTags(prev => [...prev, value]);
                // Find matching row and select
                const match = variationEdit.find(v => v.serial_no === value);
                if (match) {
                    setCheckedVariations(prev => prev.includes(match.id) ? prev : [...prev, match.id]);
                }
            }
            e.target.value = '';
        }
    };

    const handleSerialTagInputAllVariants = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            const value = e.target.value.trim();
            if (value && !serialTags.includes(value)) {
                setSerialTags(prev => [...prev, value]);
                // Find matching row in all filtered variants and select
                const match = filteredVariants.find(v => v.serial_no === value);
                if (match) {
                    setCheckedVariations(prev => prev.includes(match.id) ? prev : [...prev, match.id]);
                }
            }
            e.target.value = '';
        }
    };

    // Remove serial tag
    const handleRemoveSerialTag = (tag) => {
        setSerialTags(prev => prev.filter(t => t !== tag));
        // Unselect row
        const match = variationEdit.find(v => v.serial_no === tag);
        if (match) {
            setCheckedVariations(prev => prev.filter(id => id !== match.id));
        }
    };

    const [searchProductName, setSearchProductName] = useState('');
    const [searchCategory, setSearchCategory] = useState('');
    const [searchBrand, setSearchBrand] = useState('');
    const [searchPotency, setSearchPotency] = useState('');
    const [searchVolume, setSearchVolume] = useState('');
    const [searchSku, setSearchSku] = useState('');
    const [searchBarcode, setSearchBarcode] = useState('');
    const [searchSerialNo, setSearchSerialNo] = useState('');
    const [searchSize, setSearchSize] = useState('');
    const [searchColor, setSearchColor] = useState('');
    const [activeTab, setActiveTab] = useState('products');
    const [showExportDropdown, setShowExportDropdown] = useState(false);


    // State for checked variations and print counts
    const [checkedVariations, setCheckedVariations] = useState([]);
    const [barcodeCount, setBarcodeCount] = useState(1);
    const [labelCount, setLabelCount] = useState(1);
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const [showVariationModal, setShowVariationModal] = useState(false);
    const [showVariationModalGrouped, setShowVariationModalGrouped] = useState(false);
    const [showAvailableVariantsModal, setShowAvailableVariantsModal] = useState(false);
    const [variationListProduct, setSelectedProductModelOpen] = useState([]);
    const [variationList, setVariationList] = useState([]);
    const [variationEdit, setVariationEdit] = useState([]);
    const [variationSearchTerm, setVariationSearchTerm] = useState('');
    const [selectedProductForVariants, setSelectedProductForVariants] = useState(null);
    const [selectedPotency, setSelectedPotency] = useState(null);
    const [selectedVolume, setSelectedVolume] = useState(null);
    const [activeVariantTab, setActiveVariantTab] = useState('potency');
    const { rawProducts } = useSelector(state => state.rawProduct);
    const { rawCategories } = useSelector(state => state.rawCategories);
    const { products, totalCount, totalPages, currentPage, potencies, volumes } = useSelector(state => state.finalProduct);
    const [productsLoading, setProductsLoading] = useState(true);
    const { units } = useSelector(state => state.accountingUnits);
    const { categories } = useSelector(state => state.finalCategory);
    const { brands } = useSelector(state => state.brands);

    // Server-side pagination states
    const [paginationPerPage, setPaginationPerPage] = useState(50);
    const [paginationPage, setPaginationPage] = useState(1);

    const [showLooseModal, setShowLooseModal] = useState(false);
    const [selectedVariationForLoose, setSelectedVariationForLoose] = useState(null);
    const [looseQtyInput, setLooseQtyInput] = useState('');
    const [looseVolumeInput, setLooseVolumeInput] = useState('');
    const [looseStockSource, setLooseStockSource] = useState('retail');

    // Transfer stock modal state
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [selectedVariationForTransfer, setSelectedVariationForTransfer] = useState(null);
    const [transferQtyInput, setTransferQtyInput] = useState('');
    const [transferDirection, setTransferDirection] = useState('wholesale_to_retail');

    // Direct Add Stock modal state (for products with no stock)
    const [showAddStockModal, setShowAddStockModal] = useState(false);
    const [selectedProductForStock, setSelectedProductForStock] = useState(null);
    const [stockForm, setStockForm] = useState({
        variation_id: '',
        variant_name: '',
        stock_type: 'wholesale', // 'wholesale', 'retail', 'both'
        qty: '',
        current_wholesale: '',
        price: '',
        wholesale_price: '',
        batch_no: '',
        exp_date: '',
        is_new_variant: false
    });
    const [isSubmittingStock, setIsSubmittingStock] = useState(false);


    const [inputProductName, setInputProductName] = useState('');
    const [inputCategory, setInputCategory] = useState('');
    const [inputBrand, setInputBrand] = useState('');
    const [inputPotency, setInputPotency] = useState('');
    const [inputVolume, setInputVolume] = useState('');

    // Applied filters (sent to API)
    const [appliedFilters, setAppliedFilters] = useState({
        productName: '',
        categoryId: '',
        brandId: '',
        potency: '',
        volume: '',
    });


    const handleAdd = () => {
        setSelectedProduct(null);
        setModalHeading('Create New Product');
        setShowModal(true);
    }

    // useEffect(() => {
    //     const company = JSON.parse(localStorage.getItem('company'));
    //     if (company) {
    //         const companyId = company.company?.id;
    //         setProductsLoading(true);
    //         dispatch(fetchFinalProducts({ 
    //             companyId, 
    //             page: paginationPage, 
    //             limit: paginationPerPage 
    //         })).finally(() => {
    //             setProductsLoading(false);
    //         });
    //         dispatch(fetchCategories(companyId));
    //         dispatch(fetchRawCategories(companyId));
    //         dispatch(getProducts(companyId));
    //         dispatch(fetchUnits(companyId));
    //     }
    // }, [dispatch, paginationPage, paginationPerPage]);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            setProductsLoading(true);

            const filtersToSend = {
                ...appliedFilters,
                productValueType: activeTab === 'loose' ? 'Loose' : (activeTab === 'products' ? 'Products' : '')
            };

            dispatch(fetchFinalProducts({
                companyId,
                page: paginationPage,
                limit: paginationPerPage,
                filters: filtersToSend
            })).finally(() => {
                setProductsLoading(false);
            });

            dispatch(fetchCategories(companyId));
            dispatch(fetchRawCategories(companyId));
            dispatch(getProducts(companyId));
            dispatch(fetchUnits(companyId));
            dispatch(fetchBrands(companyId));
        }
    }, [dispatch, paginationPage, paginationPerPage, appliedFilters, activeTab]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setPaginationPage(1);
        setCheckedVariations([]);
        setSerialTags([]);
    };



    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setAppliedFilters({
            productName: inputProductName,
            categoryId: inputCategory,
            brandId: inputBrand,
            potency: inputPotency,
            volume: inputVolume,
        });
        setPaginationPage(1); // Reset to page 1 when filters are applied
    };

    const handleClearFilters = () => {
        setInputProductName('');
        setInputCategory('');
        setInputBrand('');
        setInputPotency('');
        setInputVolume('');
        setAppliedFilters({
            productName: '',
            categoryId: '',
            brandId: '',
            potency: '',
            volume: '',
        });
        setPaginationPage(1);
    };

    const handleExport = async (type) => {
        try {
            setShowExportDropdown(false);

            const brandName = type === 'wsi' ? 'WSI' : type === 'wsg' ? 'WSG' : 'Reckeweg';

            const result = await Swal.fire({
                title: `Export ${brandName} Stock`,
                text: 'Select stock type for export calculation (Current Stock - Ideal Stock):',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Wholesale',
                confirmButtonColor: '#0d6efd',
                denyButtonText: 'Retail',
                denyButtonColor: '#198754',
                cancelButtonText: 'Cancel',
                cancelButtonColor: '#6c757d',
            });

            if (result.isDismissed) {
                return;
            }

            const isWholesale = result.isConfirmed;
            const stockType = isWholesale ? 'wholesale' : 'retail';
            const stockTypeLabel = isWholesale ? 'Wholesale' : 'Retail';

            // Show loading indicator
            Swal.fire({
                title: `Exporting ${brandName} (${stockTypeLabel})...`,
                text: 'Please wait while we generate the export file.',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            const company = JSON.parse(localStorage.getItem('company'));
            if (!company) {
                Swal.close();
                return;
            }
            const companyId = company.company?.id;

            const response = await fetch(`${API_URL}/jnm-export/${type}/${companyId}?stockType=${stockType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Export failed: ${response.statusText}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${brandName}_${stockTypeLabel}_Export_${companyId}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            Swal.close();

            Swal.fire({
                icon: 'success',
                title: 'Exported!',
                text: `${brandName} (${stockTypeLabel}) file exported successfully.`,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
        } catch (error) {
            Swal.close();
            console.error('Export error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Export Failed!',
            });
        }
        setShowExportDropdown(false);
    };



    const handlePageChange = (page) => {
        setPaginationPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPaginationPerPage(newPerPage);
        setPaginationPage(page);
    };

    const handleFormSubmit = (formData) => {
        if (selectedProduct && selectedProduct.id != null) {
            dispatch(updateProduct({ id: selectedProduct.id, productData: formData }));
        } else {
            dispatch(createProduct(formData));
        }
        setShowModal(false);
    };

    const handleEditTax = (productData) => {
        setSelectedProduct(productData);
        setModalHeading('Edit Product');
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Product.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteFinalProduct(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Product has been deleted.',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
            }
        });
    };

    const handleOpenLooseModal = (variation) => {
        setSelectedVariationForLoose(variation);
        const hasRetail = parseFloat(variation.qty) > 0;
        const hasWholesale = parseFloat(variation.current_wholesale) > 0;
        const defaultSource = hasRetail ? 'retail' : (hasWholesale ? 'wholesale' : 'retail');
        setLooseStockSource(defaultSource);
        setLooseQtyInput('1');
        const match = (variation.variant_name || '').match(/([0-9.]+)\s*(ML|GM|G|KG|L)/i);
        const defaultVol = match ? parseFloat(match[1]) : 30;
        setLooseVolumeInput(String(defaultVol));
        setShowLooseModal(true);
    };

    const handleLooseQtyChange = (val) => {
        setLooseQtyInput(val);
        const match = (selectedVariationForLoose?.variant_name || '').match(/([0-9.]+)\s*(ML|GM|G|KG|L)/i);
        const defaultVol = match ? parseFloat(match[1]) : 30;
        const totalVol = (parseFloat(val) || 0) * defaultVol;
        setLooseVolumeInput(totalVol > 0 ? String(totalVol) : '');
    };

    const handleLooseSubmit = async () => {
        if (!looseQtyInput || parseFloat(looseQtyInput) <= 0) {
            Swal.fire('Error', 'Please enter a valid quantity to move', 'error');
            return;
        }

        const isWholesale = looseStockSource === 'wholesale';
        const availableStock = isWholesale
            ? (parseFloat(selectedVariationForLoose.current_wholesale) || 0)
            : (parseFloat(selectedVariationForLoose.qty) || 0);

        if (parseFloat(looseQtyInput) > availableStock) {
            Swal.fire('Error', `Quantity to move cannot exceed available ${isWholesale ? 'wholesale' : 'retail'} stock (${availableStock})`, 'error');
            return;
        }

        try {
            const res = await dispatch(moveToLoose({
                variationId: selectedVariationForLoose.id,
                loose_qty_to_add: looseQtyInput,
                loose_volume_to_add: looseVolumeInput,
                from_stock_type: looseStockSource
            })).unwrap();

            setShowLooseModal(false);

            // Update local state
            setVariationEdit(prev => prev.map(v =>
                v.id === selectedVariationForLoose.id
                    ? {
                        ...v,
                        qty: isWholesale ? v.qty : (parseFloat(v.qty) - parseFloat(looseQtyInput)),
                        current_wholesale: isWholesale ? (parseFloat(v.current_wholesale) - parseFloat(looseQtyInput)) : v.current_wholesale
                    }
                    : v
            ));

            Swal.fire({
                icon: 'success',
                title: 'Transferred to JNM LOOSE!',
                text: res.message || `Transferred ${looseQtyInput} unit(s) from ${isWholesale ? 'Wholesale' : 'Retail'} to JNM LOOSE Brand product stock`,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
            });
        } catch (error) {
            Swal.fire('Error', error.message || error || 'Failed to move to loose', 'error');
        }
    };

    const handleOpenTransferModal = (variation, direction) => {
        setSelectedVariationForTransfer(variation);
        setTransferDirection(direction);
        setTransferQtyInput('');
        setShowTransferModal(true);
    };

    const handleTransferSubmit = async () => {
        if (!transferQtyInput || parseFloat(transferQtyInput) <= 0) {
            Swal.fire('Error', 'Please enter a valid quantity', 'error');
            return;
        }

        const maxQty = transferDirection === 'wholesale_to_retail'
            ? parseFloat(selectedVariationForTransfer.current_wholesale) || 0
            : parseFloat(selectedVariationForTransfer.qty) || 0;

        if (parseFloat(transferQtyInput) > maxQty) {
            Swal.fire('Error', `Quantity to transfer cannot exceed available stock (${maxQty})`, 'error');
            return;
        }

        try {
            await dispatch(transferStock({
                variationId: selectedVariationForTransfer.id,
                qty_to_transfer: transferQtyInput,
                direction: transferDirection
            })).unwrap();

            setShowTransferModal(false);

            // Update local state
            const transferAmt = parseFloat(transferQtyInput);
            setVariationEdit(prev => prev.map(v =>
                v.id === selectedVariationForTransfer.id
                    ? {
                        ...v,
                        qty: transferDirection === 'wholesale_to_retail'
                            ? (parseFloat(v.qty) || 0) + transferAmt
                            : (parseFloat(v.qty) || 0) - transferAmt,
                        current_wholesale: transferDirection === 'wholesale_to_retail'
                            ? (parseFloat(v.current_wholesale) || 0) - transferAmt
                            : (parseFloat(v.current_wholesale) || 0) + transferAmt
                    }
                    : v
            ));

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: transferDirection === 'wholesale_to_retail'
                    ? 'Stock transferred from Wholesale to Retail'
                    : 'Stock transferred from Retail to Wholesale',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        } catch (error) {
            Swal.fire('Error', error.message || 'Failed to transfer stock', 'error');
        }
    };

    // Handlers for Add Stock directly (for products with no stock)
    const handleOpenAddStockModal = (product) => {
        setSelectedProductForStock(product);

        const variations = Array.isArray(product?.variations) ? product.variations : [];
        const firstVar = variations.length > 0 ? variations[0] : null;

        // Pricing defaults
        const defaultRetailPrice = firstVar?.price || product?.final_selling_price || product?.sale_cost || product?.mrp_price || '';
        const defaultWholesalePrice = firstVar?.wholesale_price || product?.wholesale_price || defaultRetailPrice || '';

        // Check if there are available variants
        const availVariants = Array.isArray(product?.AvailableVariants) ? product.AvailableVariants : [];
        const defaultVariantName = firstVar
            ? firstVar.variant_name
            : (availVariants.length > 0 ? `${availVariants[0].potency || ''} ${availVariants[0].volume || ''}`.trim() : (product?.name || 'Standard'));

        setStockForm({
            variation_id: firstVar ? firstVar.id : '',
            variant_name: defaultVariantName,
            stock_type: 'wholesale',
            qty: '',
            current_wholesale: '',
            price: defaultRetailPrice ? parseFloat(defaultRetailPrice).toString() : '',
            wholesale_price: defaultWholesalePrice ? parseFloat(defaultWholesalePrice).toString() : '',
            batch_no: firstVar?.batch_no || '',
            exp_date: firstVar?.exp_date ? new Date(firstVar.exp_date).toISOString().split('T')[0] : '',
            is_new_variant: variations.length === 0
        });

        setShowAddStockModal(true);
    };

    const handleVariationSelectForStock = (varId) => {
        if (varId === 'new') {
            setStockForm(prev => ({
                ...prev,
                variation_id: '',
                is_new_variant: true,
                variant_name: '',
            }));
            return;
        }

        const variations = Array.isArray(selectedProductForStock?.variations) ? selectedProductForStock.variations : [];
        const match = variations.find(v => String(v.id) === String(varId));
        if (match) {
            setStockForm(prev => ({
                ...prev,
                variation_id: match.id,
                variant_name: match.variant_name,
                is_new_variant: false,
                price: match.price !== null && match.price !== undefined ? parseFloat(match.price).toString() : prev.price,
                wholesale_price: match.wholesale_price !== null && match.wholesale_price !== undefined ? parseFloat(match.wholesale_price).toString() : prev.wholesale_price,
                batch_no: match.batch_no || prev.batch_no,
                exp_date: match.exp_date ? new Date(match.exp_date).toISOString().split('T')[0] : prev.exp_date
            }));
        }
    };

    const handleAddStockSubmit = async (e) => {
        if (e) e.preventDefault();

        const { stock_type, qty, current_wholesale, price, wholesale_price, variation_id, variant_name, batch_no, exp_date } = stockForm;

        const retailQtyNum = parseFloat(qty) || 0;
        const wholesaleQtyNum = parseFloat(current_wholesale) || 0;

        if (stock_type === 'wholesale' && wholesaleQtyNum <= 0) {
            Swal.fire({ icon: 'warning', title: 'Invalid Quantity', text: 'Please enter wholesale quantity greater than 0.' });
            return;
        }
        if (stock_type === 'retail' && retailQtyNum <= 0) {
            Swal.fire({ icon: 'warning', title: 'Invalid Quantity', text: 'Please enter retail quantity greater than 0.' });
            return;
        }
        if (stock_type === 'both' && retailQtyNum <= 0 && wholesaleQtyNum <= 0) {
            Swal.fire({ icon: 'warning', title: 'Invalid Quantity', text: 'Please enter at least one quantity greater than 0.' });
            return;
        }

        if (stock_type === 'retail' && (!price || parseFloat(price) <= 0)) {
            Swal.fire({ icon: 'warning', title: 'Price Required', text: 'Please enter retail price (MRP).' });
            return;
        }

        if (stock_type === 'wholesale' && (!wholesale_price || parseFloat(wholesale_price) <= 0)) {
            Swal.fire({ icon: 'warning', title: 'Wholesale Price Required', text: 'Please enter wholesale price.' });
            return;
        }

        setIsSubmittingStock(true);
        try {
            const payload = {
                stock_type,
                qty: retailQtyNum,
                current_wholesale: wholesaleQtyNum,
                price: price ? parseFloat(price) : undefined,
                wholesale_price: wholesale_price ? parseFloat(wholesale_price) : undefined,
                variation_id: variation_id || undefined,
                variant_name: variant_name ? variant_name.trim() : undefined,
                batch_no: batch_no ? batch_no.trim() : undefined,
                exp_date: exp_date || undefined
            };

            const result = await dispatch(addDirectStock({
                productId: selectedProductForStock.id,
                data: payload
            })).unwrap();

            Swal.fire({
                icon: 'success',
                title: 'Stock Added Successfully!',
                text: result?.message || 'Stock updated.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });

            setShowAddStockModal(false);

            // Refresh product list
            const company = JSON.parse(localStorage.getItem('company'));
            if (company) {
                const companyId = company.company?.id;
                const filtersToSend = {
                    ...appliedFilters,
                    productValueType: activeTab === 'loose' ? 'Loose' : (activeTab === 'products' ? 'Products' : '')
                };
                dispatch(fetchFinalProducts({
                    companyId,
                    page: paginationPage,
                    limit: paginationPerPage,
                    filters: filtersToSend
                }));
            }
        } catch (error) {
            console.error('Error adding stock:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to Add Stock',
                text: typeof error === 'string' ? error : (error?.message || 'Server error occurred while adding stock.')
            });
        } finally {
            setIsSubmittingStock(false);
        }
    };

    // Handler for eye button
    const handleViewVariations = (product) => {
        if (product.variations.length > 0 && Array.isArray(product.variations)) {
            setSelectedProductModelOpen(product);
            setVariationList(product.variations.map(v => ({ ...v, product })));
            setVariationEdit(product.variations.map(v => ({ ...v, product })));
            setVariationSearchTerm('');
            console.log('Product Variations:', product.variations);
            setShowVariationModal(true);
        }
    };

    const handleViewVariationsGroup = (product) => {
        if (product.variations.length > 0 && Array.isArray(product.variations)) {
            setSelectedProductModelOpen(product);
            setVariationList(product.variations.map(v => ({ ...v, product })));
            setVariationEdit(product.variations.map(v => ({ ...v, product })));
            setVariationSearchTerm('');
            console.log('Product Variations:', groupedVariations);
            setShowVariationModalGrouped(true);
        }
    };

    const handleViewAvailableVariants = (product) => {
        if (product.AvailableVariants.length > 0 && Array.isArray(product.AvailableVariants)) {
            setSelectedProductForVariants(product);
            setSelectedPotency(null);
            setSelectedVolume(null);
            setActiveVariantTab('potency');
            setShowAvailableVariantsModal(true);
        }
    };

    // Handler for editing quantity/price in modal
    const handleVariationChange = (id, field, value) => {
        setVariationEdit(prev => prev.map((v) => v.id === id ? { ...v, [field]: value } : v));
    };

    // Checkbox handler for selecting variations
    const handleVariationCheck = (id, checked) => {
        setCheckedVariations(prev => {
            let updated;
            if (checked) {
                updated = [...prev, id];
            } else {
                updated = prev.filter(cid => cid !== id);
            }
            const selectedSerials = variationEdit
                .filter(v => updated.includes(v.id) && v.serial_no)
                .map(v => v.serial_no);
            setSerialTags(selectedSerials);
            return updated;
        });
    }

    const handlePrintSelectedSafe = () => {
        const selected = filteredVariants.filter(v => checkedVariations.includes(v.id));
        let printHtml = '<html><head><title>Print Barcodes & Labels</title><style>' +
            '@media print { @page { margin: 0; } body { margin: 0; } }' +
            'body { margin: 0; padding: 0; }' +
            '.barcode-container { width: 50mm; height: 22mm; display: flex; flex-direction: column; justify-content: center; align-items: center; font-size: 12px; page-break-after: always; }' +
            '.barcode-container img { width: auto; height: auto; max-width: 100%; max-height: 70%; }' +
            '.label-container { width: 50mm; height: 22mm; display: flex; flex-direction: column; justify-content: center; font-family: Arial, sans-serif; font-size: 12px; margin-left: 15px; page-break-after: always; }' +
            '.row { display: flex; }' +
            '</style></head><body>';

        selected.forEach(row => {
            for (let i = 0; i < barcodeCount; i++) {
                if (row?.barcode_image) {
                    printHtml += `<div className="barcode-container"><img src="${API_URL}${row.barcode_image}" alt="${row.barcode}" /></div>`;
                }
            }
            for (let j = 0; j < labelCount; j++) {
                const art_no = row.product?.sku || variationListProduct.Product?.sku || '';
                const [size, colour] = row.variant_name ? row.variant_name.split('-') : ['', ''];
                const mrp = row.price || '';
                printHtml += `<div className="label-container">
                <div className="row" style="margin-bottom:1mm;"><span>ART: <b>${art_no}</b></span></div>
                <div className="row" style="margin-bottom:1mm;"><span>SIZE: <b>${size || ''}</b></span><span style="margin-left: 2mm;">MRP: <b>${mrp || '0'}/-</b></span></div>
                <div className="row" style="margin-bottom:1mm;"><span>COLOUR: <b>${colour || 'None'}</b></span></div>
                <div className="row"><span>Serial No.: <b>${row.serial_no || ''}</b></span></div>
            </div>`;
            }
        });
        printHtml += `<script>
        window.onload = function() {
            var imgs = document.images;
            var loaded = 0;
            var total = imgs.length;
            function checkLoaded() {
                if (loaded === total) {
                    window.print();
                }
            }
            if (total === 0) {
                window.print();
                return;
            }
            for (var i = 0; i < total; i++) {
                if (imgs[i].complete) {
                    loaded++;
                    checkLoaded();
                } else {
                    imgs[i].onload = function() {
                        loaded++;
                        checkLoaded();
                    };
                    imgs[i].onerror = function() {
                        loaded++;
                        checkLoaded();
                    };
                }
            }
        }
    <\/script>`;
        printHtml += '</body></html>';
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Popup blocked! Please allow popups for printing.');
            return;
        }
        printWindow.document.write(printHtml);
        printWindow.document.close();
        printWindow.focus();
    };

    const handlePrintSelected = () => {
        const selected = variationEdit.filter(v => checkedVariations.includes(v.id));
        let printHtml = '<html><head><title>Print Barcodes & Labels</title><style>' +
            '@media print { @page { margin: 0; } body { margin: 0; } }' +
            'body { margin: 0; padding: 0; }' +
            '.barcode-container { width: 50mm; height: 22mm; display: flex; flex-direction: column; justify-content: center; align-items: center; font-size: 12px; page-break-after: always; }' +
            '.barcode-container img { width: auto; height: auto; max-width: 100%; max-height: 70%; }' +
            '.label-container { width: 50mm; height: 22mm; display: flex; flex-direction: column; justify-content: center; font-family: Arial, sans-serif; font-size: 12px; margin-left: 15px; page-break-after: always; }' +
            '.row { display: flex; }' +
            '</style></head><body>';

        selected.forEach(row => {
            for (let i = 0; i < barcodeCount; i++) {
                if (row.barcode_image) {
                    printHtml += `<div className="barcode-container"><img src="${API_URL}${row.barcode_image}" alt="${row.barcode}" /></div>`;
                }
            }
            for (let j = 0; j < labelCount; j++) {
                const art_no = row.product?.sku || variationListProduct.Product?.sku || '';
                const [size, colour] = row.variant_name ? row.variant_name.split('-') : ['', ''];
                const mrp = row.price || '';
                printHtml += `<div className="label-container">
                <div className="row" style="margin-bottom:1mm;"><span>ART: <b>${art_no}</b></span></div>
                <div className="row" style="margin-bottom:1mm;"><span>SIZE: <b>${size || ''}</b></span><span style="margin-left: 2mm;">MRP: <b>${mrp || '0'}/-</b></span></div>
                <div className="row" style="margin-bottom:1mm;"><span>COLOUR: <b>${colour || 'None'}</b></span></div>
                <div className="row"><span>Serial No.: <b>${row.serial_no || ''}</b></span></div>
            </div>`;
            }
        });
        printHtml += `<script>
        window.onload = function() {
            var imgs = document.images;
            var loaded = 0;
            var total = imgs.length;
            function checkLoaded() {
                if (loaded === total) {
                    window.print();
                }
            }
            if (total === 0) {
                window.print();
                return;
            }
            for (var i = 0; i < total; i++) {
                if (imgs[i].complete) {
                    loaded++;
                    checkLoaded();
                } else {
                    imgs[i].onload = function() {
                        loaded++;
                        checkLoaded();
                    };
                    imgs[i].onerror = function() {
                        loaded++;
                        checkLoaded();
                    };
                }
            }
        }
    <\/script>`;
        printHtml += '</body></html>';
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Popup blocked! Please allow popups for printing.');
            return;
        }
        printWindow.document.write(printHtml);
        printWindow.document.close();
        printWindow.focus();
    };

    const handleSaveVariations = async () => {
        try {
            const modifiedVariations = variationEdit.filter((variation, index) => {
                const originalVariation = variationList[index];
                return (
                    variation.serial_no !== originalVariation?.serial_no ||
                    variation.price !== originalVariation?.price ||
                    variation.wholesale_price !== originalVariation?.wholesale_price ||
                    variation.qty !== originalVariation?.qty ||
                    variation.current_wholesale !== originalVariation?.current_wholesale ||
                    variation.batch_no !== originalVariation?.batch_no ||
                    variation.exp_date !== originalVariation?.exp_date ||
                    variation.price_date !== originalVariation?.price_date
                );
            });

            const updatePromises = modifiedVariations.map(variation => {
                const updateData = {
                    serial_no: variation.serial_no,
                    price: variation.price,
                    wholesale_price: variation.wholesale_price,
                    qty: variation.qty,
                    current_wholesale: variation.current_wholesale,
                    batch_no: variation.batch_no,
                    exp_date: variation.exp_date,
                    price_date: variation.price_date
                };
                return dispatch(updateProductVariation({
                    variationId: variation.id,
                    updateData
                }));
            });

            await Promise.all(updatePromises);
            setVariationList(variationEdit);
            setShowVariationModal(false);

            Swal.fire({
                icon: 'success',
                title: 'Updated!',
                text: 'Variations have been updated successfully.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
            dispatch(fetchFinalProducts({ company_id: localStorage.getItem('company_id') || 4 }));
        } catch (error) {
            console.error('Error updating variations:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Failed to update variations. Please try again.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
        }
    };

    const filteredVariations = variationEdit.filter(variation => {
        if (!variationSearchTerm) return true;
        const searchLower = variationSearchTerm.toLowerCase();
        return (
            (variation.variant_name && variation.variant_name.toLowerCase().includes(searchLower)) ||
            (variation.barcode && variation.barcode.toLowerCase().includes(searchLower)) ||
            (variation.serial_no && variation.serial_no.toLowerCase().includes(searchLower)) ||
            (variation.batch_no && variation.batch_no.toLowerCase().includes(searchLower))
        );
    });

    const groupBy = (array, key) =>
        array.reduce((acc, item) => {
            const groupKey = item[key] || 'Unknown';
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {});

    const normalizeVariantStr = (s) => {
        if (!s) return '';
        return String(s)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace(/gms/g, 'gm')
            .replace(/millilitre/g, 'ml')
            .replace(/[^a-z0-9]/g, '');
    };

    const parseVariantParts = (vName) => {
        if (!vName) return { potency: '', volume: '' };
        const clean = String(vName).trim().replace(/-+$/, '');
        
        // Match ending volume patterns like -100ML, 100ML, -25GM, 550GM, 30 CAPS, etc.
        const volMatch = clean.match(/[-_\s]*(\d+\s*(?:ml|gm|gms|g|caps|tablets|tabs))\s*$/i);
        if (volMatch) {
            const volume = volMatch[1].trim();
            const potency = clean.slice(0, volMatch.index).replace(/[-_\s]+$/, '').trim();
            return { potency, volume };
        }
        
        // Split by hyphen or underscore if present
        const parts = clean.split(/[-_]/);
        if (parts.length > 1) {
            return { potency: parts[0].trim(), volume: parts.slice(1).join('-').trim() };
        }
        
        return { potency: clean, volume: '' };
    };

    const findIdealStockRecord = (idealStocks, variantName) => {
        if (!Array.isArray(idealStocks) || idealStocks.length === 0) return null;
        if (idealStocks.length === 1 && !idealStocks[0].potency && !idealStocks[0].volume) {
            return idealStocks[0];
        }

        const { potency, volume } = parseVariantParts(variantName);
        const normPot = normalizeVariantStr(potency);
        const normVol = normalizeVariantStr(volume);

        const matchesPotency = (isPot, nPot) => {
            if (!nPot && !isPot) return true;
            if (nPot === isPot) return true;
            if ((nPot === 'q' || nPot === 'mt') && (isPot === 'q' || isPot === 'mt')) return true;
            if (isPot === nPot + 'ch' || nPot === isPot + 'ch') return true;
            if (isPot === nPot + 'x' || nPot === isPot + 'x') return true;
            if ((nPot === 'bc' || nPot === '') && (isPot === 'bc' || isPot === '')) return true;
            return false;
        };

        const matchesVolume = (isVol, nVol) => {
            if (!nVol && !isVol) return true;
            return isVol === nVol;
        };

        // 1. If both potency and volume are present on variant:
        if (normPot && normVol) {
            const match = idealStocks.find(is => {
                const isPot = normalizeVariantStr(is.potency);
                const isVol = normalizeVariantStr(is.volume);
                return matchesVolume(isVol, normVol) && matchesPotency(isPot, normPot);
            });
            if (match) return match;
            // Strict: never fall back to a different volume
            return null;
        }

        // 2. If only volume is present on variant:
        if (normVol) {
            let match = idealStocks.find(is => {
                const isVol = normalizeVariantStr(is.volume);
                const isPot = normalizeVariantStr(is.potency);
                return isVol === normVol && (isPot === '' || isPot === 'q' || isPot === 'mt' || isPot === 'bc');
            });
            if (match) return match;
            match = idealStocks.find(is => normalizeVariantStr(is.volume) === normVol);
            if (match) return match;
            return null;
        }

        // 3. If only potency is present on variant:
        if (normPot) {
            const match = idealStocks.find(is => {
                const isPot = normalizeVariantStr(is.potency);
                const isVol = normalizeVariantStr(is.volume);
                return isVol === '' && matchesPotency(isPot, normPot);
            });
            if (match) return match;
            return null;
        }

        // 4. Product-level record fallback ONLY if record has neither potency nor volume
        const globalRec = idealStocks.find(is => !is.potency && !is.volume);
        if (globalRec) return globalRec;

        return null;
    };

    const grouped = groupBy(variationEdit, 'variant_name');
    const groupedVariations = Object.entries(grouped).map(([variant_name, items]) => ({
        variant_name,
        count: items.length,
        items
    }));

    const handleDownloadBarcode = (barcodeImage, barcode) => {
        if (barcodeImage) {
            const link = document.createElement('a');
            link.href = `${API_URL}${barcodeImage}`;
            link.download = `barcode_${barcode}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handlePrintBarcode = (barcodeImage, barcode) => {
        if (barcodeImage) {
            const printWindow = window.open('', '_blank');
            if (!printWindow) {
                alert('Popup blocked! Please allow popups for printing.');
                return;
            }
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Print Barcode</title>
                        <style>
                            @media print {
                                @page { margin: 0; }
                                body { margin: 0; margin-left: 15px; }
                            }
                            body { margin: 0; padding: 0; margin-left: 15px; }
                            .barcode-container {
                                width: 50mm;
                                height: 22mm;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                font-size: 12px;
                                page-break-after: always;
                            }
                            .barcode-container img {
                                width: auto;
                                height: auto;
                                max-width: 100%;
                                max-height: 70%;
                            }
                        </style>
                    </head>
                    <body>
                        <div className="barcode-container">
                            <img src="${API_URL}${barcodeImage}" onload="window.print()" alt="${barcode}" />
                        </div>
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
        }
    };

    // Handle batch number update
    const handleBatchNoChange = (id, value) => {
        setVariationEdit(prev => prev.map((v) => v.id === id ? { ...v, batch_no: value } : v));
    };

    const handlePrintLabel = ({ product, row }) => {
        const logoSrc = 'https://cdn-icons-png.flaticon.com/512/727/727803.png';
        const art_no = row.product.sku || product.Product?.sku;
        const [size, colour] = row.variant_name.split('-');
        const mrp = row.price;
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Popup blocked! Please allow popups for printing.');
            return;
        }
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Label</title>
                    <style>
                        @media print {
                            @page { margin: 0; }
                            body { margin: 0; margin-left: 40px; }
                        }
                        body { margin: 0; padding: 0; margin-left: 40px; }
                        .label-container {
                            width: 50mm;
                            height: 22mm;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            font-family: Arial, sans-serif;
                            font-size: 12px;
                            page-break-after: always;
                        }
                        .row { display: flex; }
                    </style>
                </head>
                <body>
                    <div className="label-container">
                        <div className="row" style="margin-bottom:1mm;">
                            <span>ART: <b>${art_no || ''}</b></span>
                        </div>
                        <div className="row" style="margin-bottom:1mm;">
                            <span>SIZE: <b>${size || ''}</b></span>
                            <span style="margin-left: 2mm;">MRP: <b>${mrp || '0'}/-</b></span>
                        </div>
                        <div className="row" style="margin-bottom:1mm;">
                            <span>COLOUR: <b>${colour || 'None'}</b></span>
                        </div>
                        <div className="row">
                             <span>Serial No.: <b>${row.serial_no || ''}</b></span>
                        </div>
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    const handlePrintBarcodeAndLabel = ({ product, row }) => {
        const { barcode_image, barcode } = row;
        const art_no = row.product.sku || product.Product?.sku;
        const [size, colour] = row.variant_name.split('-');
        const mrp = row.price;
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Barcode & Label</title>
                    <style>
                        @media print {
                            @page { margin: 0; }
                            body { margin: 0; margin-left: 5px; }
                        }
                        body { margin: 0; padding: 0; margin-left: 5px; }
                        .barcode-container {
                            width: 50mm;
                            height: 22mm;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            font-size: 12px;
                            page-break-after: always;
                        }
                        .barcode-container img {
                            width: auto;
                            height: auto;
                            max-width: 100%;
                            max-height: 70%;
                        }
                        .label-container {
                            width: 50mm;
                            height: 22mm;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            font-family: Arial, sans-serif;
                            font-size: 12px;
                            page-break-after: always;
                        }
                        .row { display: flex; }
                    </style>
                </head>
                <body>
                    <div className="main-container">
                        <div className="barcode-container">
                            <img src="${API_URL}${barcode_image}" onload="window.print()" alt="${barcode}" />
                        </div>
                        <div className="label-container" style="margin-left: 15px;">
                            <div className="row" style="margin-bottom:1mm;">
                                <span>ART: <b>${art_no}</b></span>
                            </div>
                            <div className="row" style="margin-bottom:1mm;">
                                <span>SIZE: <b>${size || ''}</b></span>
                                <span style="margin-left: 2mm;">MRP: <b>${mrp || '0'}/-</b></span>
                            </div>
                            <div className="row">
                                <span>COLOUR: <b>${colour || 'None'}</b></span>
                            </div>
                            <div className="row">
                                <span>Serial No.: <b>${row.serial_no || ''}</b></span>
                            </div>
                        </div>
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
    };

    const handleCloseVariationModal = () => {
        setShowVariationModal(false);
        setVariationSearchTerm('');
        setCheckedVariations([]);
        setSerialTags([]);
    };

    const handleCloseVariationModalGrouped = () => {
        setShowVariationModalGrouped(false);
    };

    const variationsColumns = [
        {
            name: '-',
            cell: row => (
                <input
                    type="checkbox"
                    checked={checkedVariations.includes(row.id)}
                    onChange={e => handleVariationCheck(row.id, e.target.checked)}
                />
            ),
            width: '60px'
        },
        {
            name: '#',
            cell: (row, index) => index + 1,
            width: '60px',
            sortable: true
        },
        {
            name: 'Image',
            cell: row => (
                <img
                    src={`${API_URL}${row.image || row.product.product_image}`}
                    alt={row.name}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = './logo.png';
                    }}
                    style={{ height: '50px', width: "50px", objectFit: 'cover' }}
                />
            ),
            width: '60px',
            sortable: true
        },
        {
            name: 'Product Name',
            selector: row => row.product?.name || '',
            sortable: true,
            width: '200px'
        },
        {
            name: 'Retail Stock',
            cell: row => (
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={row.qty ?? ''}
                    onChange={e => handleVariationChange(row.id, 'qty', e.target.value)}
                    style={{ width: '90px' }}
                />
            ),
            sortable: true,
            width: '130px'
        },
        {
            name: 'Wholesale Stock',
            cell: row => (
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={row.current_wholesale ?? ''}
                    onChange={e => handleVariationChange(row.id, 'current_wholesale', e.target.value)}
                    style={{ width: '90px' }}
                />
            ),
            sortable: true,
            width: '160px'
        },
        {
            name: 'Total Qty',
            cell: row => (
                <span className="badge bg-dark text-white fw-bold">
                    {(Number(row.qty) || 0) + (Number(row.current_wholesale) || 0)}
                </span>
            ),
            sortable: true,
            width: '90px'
        },
        {
            name: 'Loose Stock',
            selector: row => row.loose_qty || '0',
            sortable: true,
        },
        {
            name: 'Variation Name',
            selector: row => row.variant_name,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Price',
            cell: row => (
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={row.price || ''}
                    onChange={e => handleVariationChange(row.id, 'price', e.target.value)}
                    style={{ width: '100px' }}
                />
            ),
            width: '120px'
        },
        {
            name: 'Wholesale Price',
            cell: row => (
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={row.wholesale_price || ''}
                    onChange={e => handleVariationChange(row.id, 'wholesale_price', e.target.value)}
                    style={{ width: '100px' }}
                />
            ),
            width: '120px'
        },
        {
            name: 'Barcode',
            selector: row => row.barcode,
            sortable: true,
            width: '120px',
            cell: row => (
                <div className="text-truncate" title={row.barcode}>
                    {row.barcode}
                </div>
            )
        },
        {
            name: 'Barcode Image',
            cell: row => (
                row?.barcode_image != null ? (
                    <img
                        src={`${API_URL}${row?.barcode_image}`}
                        alt={row.barcode}
                        style={{ height: '40px', width: 'auto' }}
                        className="img-thumbnail"
                    />
                ) : (
                    <span className="text-muted small">No Image</span>
                )
            ),
            width: '120px'
        },
        {
            name: 'Serial No',
            cell: row => (
                <input
                    type="text"
                    className="form-control form-control-sm"
                    value={row.serial_no || ''}
                    onChange={e => handleVariationChange(row.id, 'serial_no', e.target.value)}
                    style={{ width: '140px' }}
                />
            ),
            width: '150px',
            sortable: true
        },
        {
            name: 'Batch No',
            cell: row => (
                <input
                    type="text"
                    className="form-control form-control-sm"
                    value={row.batch_no || ''}
                    onChange={e => handleVariationChange(row.id, 'batch_no', e.target.value)}
                    placeholder="Batch No"
                    style={{ width: '120px' }}
                />
            ),
            width: '130px',
            sortable: true
        },
        {
            name: 'Expiry Date',
            cell: row => (
                <input
                    type="date"
                    className="form-control form-control-sm"
                    value={row.exp_date ? new Date(row.exp_date).toISOString().split('T')[0] : ''}
                    onChange={e => handleVariationChange(row.id, 'exp_date', e.target.value)}
                    style={{ width: '140px' }}
                />
            ),
            width: '150px',
            sortable: true
        },
        {
            name: 'Price Date',
            cell: row => (
                <input
                    type="date"
                    className="form-control form-control-sm"
                    value={row.price_date ? new Date(row.price_date).toISOString().split('T')[0] : ''}
                    onChange={e => handleVariationChange(row.id, 'price_date', e.target.value)}
                    style={{ width: '140px' }}
                />
            ),
            width: '150px',
            sortable: true
        },
        // {
        //     name: 'Segment',
        //     selector: row => row.segment,
        //     sortable: true
        // },
        // {
        //     name: 'Sub-Segment',
        //     selector: row => row.subSegment,
        //     sortable: true
        // },
        {
            name: 'Actions',
            cell: row => (
                <div className="btn-group btn-group-sm" role="group">
                    {row.barcode_image && (
                        <>
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handleDownloadBarcode(row.barcode_image, row.barcode)}
                                title="Download Barcode"
                            >
                                <Download />
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => handlePrintBarcode(row.barcode_image, row.barcode)}
                                title="Print Barcode"
                            >
                                <Printer />
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handlePrintLabel({ product: variationListProduct, row })}
                                title="Print Label"
                            >
                                <PrinterCheck />
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handlePrintBarcodeAndLabel({ product: variationListProduct, row })}
                                title="Print Barcode & Label"
                            >
                                <ReceiptText />
                            </button>

                        </>
                    )}
                    <button
                        type="button"
                        className="btn btn-outline-info btn-sm"
                        onClick={() => handleOpenLooseModal(row)}
                        title="Add Loose Quantity"
                    >
                        Add to Loose
                    </button>
                    {parseFloat(row.current_wholesale) > 0 && (
                        <button
                            type="button"
                            className="btn btn-outline-success btn-sm"
                            onClick={() => handleOpenTransferModal(row, 'wholesale_to_retail')}
                            title="Transfer Wholesale → Retail"
                        >
                            W→R
                        </button>
                    )}
                    {parseFloat(row.qty) > 0 && (
                        <button
                            type="button"
                            className="btn btn-outline-warning btn-sm"
                            onClick={() => handleOpenTransferModal(row, 'retail_to_wholesale')}
                            title="Transfer Retail → Wholesale"
                        >
                            R→W
                        </button>
                    )}
                </div>
            ),
            width: '280px'
        }
    ];

    const productsColumn = [
        {
            name: '#',
            cell: (row, index) => (paginationPage - 1) * paginationPerPage + index + 1,
            width: '50px'
        },
        {
            name: 'Image',
            cell: row => (
                <img
                    src={`${API_URL}${row.product_image}`}
                    alt={row.name}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = './logo.png';
                    }}
                    style={{ height: '50px', width: "50px", objectFit: 'cover' }}
                />
            ),
            width: '100px',
            sortable: true
        },
        {
            name: 'Name',
            selector: row => row?.name || '',
            sortable: true,
            width: '200px'
        },
        {
            name: 'Category',
            selector: row => row?.RawCategory?.name || 'Unknown',
            sortable: true
        },
        {
            name: 'Brand',
            selector: row => row?.Brand?.name || 'OTHER',
            sortable: true
        },
        {
            name: 'unit',
            selector: row => row?.Unit?.name || row?.unit || '',
            sortable: true
        },
        {
            name: 'HSN / SAC',
            selector: row => `${row?.taxes?.hsn_code || ""} (${row?.taxes?.rate || "0"} %)`,
            sortable: true
        },
        {
            name: 'Type',
            selector: row => row?.product_value_type || '',
            sortable: true
        },
        {
            name: 'Total Quantity',
            sortable: true,
            cell: row => {
                const totalRetail = Array.isArray(row?.variations)
                    ? row.variations.reduce((sum, v) => sum + (Number(v.qty) || 0), 0)
                    : 0;
                const totalWholesale = Array.isArray(row?.variations)
                    ? row.variations.reduce((sum, v) => sum + (Number(v.current_wholesale) || 0), 0)
                    : 0;
                const totalQty = totalRetail + totalWholesale;
                return (
                    <div className="d-flex align-items-center flex-wrap gap-1">
                        {totalQty > 0 ? (
                            <>
                                <span className="fw-bold fs-14" title={`Retail: ${totalRetail} | Wholesale: ${totalWholesale}`}>{totalQty}</span>
                                {Array.isArray(row?.variations) && row.variations.length > 0 && (
                                    <span
                                        className="text-info cursor-pointer ms-2"
                                        title={`Total: ${totalQty} (Retail: ${totalRetail}, Wholesale: ${totalWholesale})`}
                                        onClick={() => handleViewVariationsGroup(row)}
                                    >
                                        <Eye size={16} />
                                    </span>
                                )}
                            </>
                        ) : (
                            <div className="d-flex align-items-center gap-1">
                                <span className="badge bg-danger text-white fw-bold fs-12 px-2 py-1">0</span>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary py-0 px-2 fs-11 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                                    style={{ height: '24px' }}
                                    onClick={() => handleOpenAddStockModal(row)}
                                    title="No stock! Click to add stock in wholesale or retail"
                                >
                                    <Plus size={12} /> Add Stock
                                </button>
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    {Array.isArray(row?.AvailableVariants) && row.AvailableVariants.length > 0 && (
                        <span
                            className="text-info cursor-pointer me-2"
                            title="View Available Variants"
                            onClick={() => handleViewAvailableVariants(row)}
                        >
                            <Airplay />
                        </span>
                    )}
                    {Array.isArray(row?.variations) && row.variations.length > 0 && (
                        <span
                            className="text-info cursor-pointer me-2"
                            title="View Variations"
                            onClick={() => handleViewVariations(row)}
                        >
                            <Eye />
                        </span>
                    )}
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '180px'
        }
    ];

    const looseProductsColumn = [
        {
            name: '#',
            cell: (row, index) => (paginationPage - 1) * paginationPerPage + index + 1,
            width: '50px'
        },
        {
            name: 'Image',
            cell: row => (
                <img
                    src={`${API_URL}${row.product_image}`}
                    alt={row.name}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = './logo.png';
                    }}
                    style={{ height: '50px', width: "50px", objectFit: 'cover' }}
                />
            ),
            width: '80px',
            sortable: true
        },
        {
            name: 'Medicine Name',
            cell: row => (
                <div>
                    <div className="fw-bold fs-14">{row?.name || ''}</div>
                    <div className="d-flex flex-wrap gap-1 mt-1">
                        {row?.product_contain_type && (
                            <span className="badge bg-primary-transparent text-primary" style={{ fontSize: '11px' }}>
                                {row.product_contain_type}
                            </span>
                        )}
                        {row?.sku && (
                            <span className="badge bg-light text-muted" style={{ fontSize: '11px' }}>
                                SKU: {row.sku}
                            </span>
                        )}
                    </div>
                </div>
            ),
            sortable: true,
            width: '240px'
        },
        {
            name: 'Category',
            selector: row => row?.RawCategory?.name || (row?.final_category === 18 ? 'TRITURATION TABLETS' : 'Unknown'),
            sortable: true,
            width: '180px'
        },
        {
            name: 'Brand',
            selector: row => row?.Brand?.name || 'OTHER',
            sortable: true,
            width: '130px'
        },
        {
            name: 'Total Loose Stock',
            sortable: true,
            cell: row => {
                const totalLoose = Array.isArray(row?.variations)
                    ? row.variations.reduce((sum, v) => sum + (Number(v.loose_qty) || 0), 0)
                    : 0;
                const totalRetail = Array.isArray(row?.variations)
                    ? row.variations.reduce((sum, v) => sum + (Number(v.qty) || 0), 0)
                    : 0;
                const totalWholesale = Array.isArray(row?.variations)
                    ? row.variations.reduce((sum, v) => sum + (Number(v.current_wholesale) || 0), 0)
                    : 0;
                const totalQty = totalRetail + totalWholesale + totalLoose;
                const unit = row?.Unit?.name || row?.unit || 'gm';
                return (
                    <div>
                        <div className="d-flex align-items-center gap-1">
                            {totalQty > 0 ? (
                                <span className={`badge ${totalLoose > 0 ? 'bg-success' : 'bg-secondary'} fs-13 py-1 px-2`}>
                                    {totalLoose} {unit}
                                </span>
                            ) : (
                                <>
                                    <span className="badge bg-danger text-white fw-bold fs-12 px-2 py-1">0 {unit}</span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary py-0 px-2 fs-11 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm ms-1"
                                        style={{ height: '24px' }}
                                        onClick={() => handleOpenAddStockModal(row)}
                                        title="No stock! Click to add stock"
                                    >
                                        <Plus size={12} /> Add Stock
                                    </button>
                                </>
                            )}
                        </div>
                        {totalRetail > 0 && (
                            <div className="text-muted fs-11 mt-1">
                                Sealed: {totalRetail} units
                            </div>
                        )}
                    </div>
                );
            },
            width: '180px'
        },
        {
            name: 'Potencies / Variations Stock',
            cell: row => {
                if (!Array.isArray(row?.variations) || row.variations.length === 0) {
                    return <span className="text-muted fs-12">No variants</span>;
                }
                return (
                    <div className="d-flex flex-wrap gap-1 py-1" style={{ maxHeight: '75px', overflowY: 'auto' }}>
                        {row.variations.map((v, i) => (
                            <span 
                                key={i} 
                                className="badge bg-light border text-dark" 
                                style={{ fontSize: '11px', padding: '3px 6px' }}
                                title={`MRP: ₹${v.price || 0} | Retail: ${v.qty || 0} | Loose: ${v.loose_qty || 0}`}
                            >
                                <strong>{v.variant_name}</strong>: {Number(v.loose_qty) > 0 ? <span className="text-success fw-bold">{v.loose_qty} loose</span> : `${v.qty || 0} sealed`}
                            </span>
                        ))}
                    </div>
                );
            },
            grow: 2
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="d-flex align-items-center">
                    {Array.isArray(row?.AvailableVariants) && row.AvailableVariants.length > 0 && (
                        <span
                            className="text-info cursor-pointer me-2"
                            title="View Available Variants"
                            onClick={() => handleViewAvailableVariants(row)}
                        >
                            <Airplay size={18} />
                        </span>
                    )}
                    {Array.isArray(row?.variations) && row.variations.length > 0 && (
                        <span
                            className="text-info cursor-pointer me-2"
                            title="View Variations"
                            onClick={() => handleViewVariations(row)}
                        >
                            <Eye size={18} />
                        </span>
                    )}
                    <span
                        className="text-warning cursor-pointer me-2"
                        title="Edit Product"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen size={18} />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        title="Delete Product"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete size={18} />
                    </span>
                </div>
            ),
            width: '140px'
        }
    ];

    // Search states for each field


    // Get unique categories, brands, potencies, and volumes for dropdowns
    const uniqueCategories = [...new Set(products.map(p => p?.RawCategory?.id).filter(Boolean))].map(
        id => products.find(p => p?.RawCategory?.id === id)?.RawCategory
    ).filter(Boolean);
    const uniqueBrands = [...new Set(products.map(p => p?.Brand?.id).filter(Boolean))].map(
        id => products.find(p => p?.Brand?.id === id)?.Brand
    ).filter(Boolean);
    const allAvailableVariants = products.flatMap(p => p.AvailableVariants || []);
    const uniquePotencies = [...new Set(allAvailableVariants.map(v => v.potency).filter(Boolean))];
    const uniqueVolumes = [...new Set(allAvailableVariants.map(v => v.volume).filter(Boolean))];

    // Filter products by each field using appliedFilters
    const filteredProducts = products.filter(product => {
        const pName = appliedFilters.productName;
        const catId = appliedFilters.categoryId;
        const bId = appliedFilters.brandId;
        const pot = appliedFilters.potency;
        const vol = appliedFilters.volume;

        if (pName && !(product.name && product.name.toLowerCase().includes(pName.toLowerCase()))) {
            return false;
        }
        if (catId) {
            const prodCat = product.category || product.final_category || product.RawCategory?.id;
            if (prodCat != catId) return false;
        }
        if (bId) {
            const prodBrand = product.brand || product.brand_id || product.Brand?.id;
            if (prodBrand != bId) return false;
        }
        if ((pot || vol) && product.AvailableVariants) {
            const matchesVariant = product.AvailableVariants.some(v => {
                return (
                    (!pot || v.potency === pot) &&
                    (!vol || v.volume === vol)
                );
            });
            if (!matchesVariant) return false;
        }
        return true;
    });

    // Gather all variants for Variants tab
    const allVariants = products.flatMap(product => product.variations.map(v => ({ ...v, product })));
    const filteredVariants = allVariants.filter(variation => {
        let size = '';
        let color = '';
        if (variation.variant_name) {
            const parts = variation.variant_name.split('-');
            size = parts[0]?.trim() || '';
            color = parts[1]?.trim() || '';
        }
        return (
            (!searchProductName || (variation.product?.name && variation.product.name.toLowerCase().includes(searchProductName.toLowerCase()))) &&
            (!searchSku || (variation.product?.sku && variation.product.sku.toLowerCase().includes(searchSku.toLowerCase()))) &&
            (!searchBarcode || (variation.barcode && variation.barcode.toLowerCase().includes(searchBarcode.toLowerCase()))) &&
            (!searchSerialNo || (variation.serial_no && variation.serial_no.toLowerCase().includes(searchSerialNo.toLowerCase()))) &&
            (!searchSize || (size && size.toLowerCase().includes(searchSize.toLowerCase()))) &&
            (!searchColor || (color && color.toLowerCase().includes(searchColor.toLowerCase())))
        );
    });

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
            </div>
            <div className="card mb-3">
                <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h3 className="text-primary mb-0">Final Products</h3>
                    <div className="d-flex gap-2 flex-wrap">
                        <div className="dropdown">
                            <button
                                className="btn btn-success dropdown-toggle"
                                type="button"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                            >
                                <Download size={16} className="me-1" />
                                Export
                            </button>
                            {showExportDropdown && (
                                <ul className="dropdown-menu show" style={{ position: 'absolute', right: 0 }}>
                                    <li>
                                        <button className="dropdown-item" onClick={() => handleExport('wsi')}>
                                            WSI
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={() => handleExport('wsg')}>
                                            WSG
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={() => handleExport('reck')}>
                                            Reckweg
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </div>
                        <button
                            className="btn btn-info text-white fw-bold me-1"
                            onClick={() => navigate("/transfer-logs")}
                        >
                            <ArrowLeftRight size={16} className="me-1" />
                            Transfer Logs
                        </button>
                        {/* <button
                            className="btn btn-warning text-dark fw-bold me-1"
                            onClick={() => navigate("/arrange-duplicate")}
                        >
                            Arrange Duplicates
                        </button> */}
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate("/raw-products", { state: { openModal: true } })}
                        >
                            + Add New
                        </button>
                    </div>
                </div>
                <div className="card-header">
                    <h6 className="mb-0">Filter Products</h6>
                    <form onSubmit={handleFilterSubmit}>
                        <div className="row g-2 align-items-end">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Product Name
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Product Name"
                                        value={inputProductName}
                                        onChange={e => setInputProductName(e.target.value)}
                                    // value={searchProductName}
                                    // onChange={e => setSearchProductName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Category
                                    </span>
                                    <select
                                        className="form-control"
                                        value={inputCategory}
                                        onChange={e => setInputCategory(e.target.value)}
                                    // value={searchCategory}
                                    // onChange={e => setSearchCategory(e.target.value)}
                                    >
                                        <option value="">All Categories</option>
                                        {rawCategories.map(cat => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Brand
                                    </span>
                                    <select
                                        className="form-control"
                                        value={inputBrand}
                                        onChange={e => setInputBrand(e.target.value)}
                                    // value={searchBrand}
                                    // onChange={e => setSearchBrand(e.target.value)}
                                    >
                                        <option value="">All Brands</option>
                                        {brands.map(brand => (
                                            <option key={brand.id} value={brand.id}>
                                                {brand.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Potency
                                    </span>
                                    <select
                                        className="form-control"
                                        value={inputPotency}
                                        onChange={e => setInputPotency(e.target.value)}
                                    // value={searchPotency}
                                    // onChange={e => setSearchPotency(e.target.value)}
                                    >
                                        <option value="">All Potencies</option>
                                        {potencies.map((pot, pte) => (
                                            <option key={pte} value={pot.potency}>
                                                {pot.potency}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="position-relative mt-3 mb-2">
                                    <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                        Volume
                                    </span>
                                    <select
                                        className="form-control"
                                        value={inputVolume}
                                        onChange={e => setInputVolume(e.target.value)}
                                    // value={searchVolume}
                                    // onChange={e => setSearchVolume(e.target.value)}
                                    >
                                        <option value="">All Volumes</option>
                                        {volumes.map((vol, vle) => (
                                            <option key={vle} value={vol.volume}>
                                                {vol.volume}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="d-flex gap-2">
                                    <button type="submit" className="btn btn-primary flex-fill">
                                        Apply Filters
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleClearFilters}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="card-body">
                    <ul className="nav nav-pills mb-3 nav-justified tab-style-5 d-flex flex-wrap gap-2" role="tablist">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'products' ? 'active' : ''}`}
                                onClick={() => handleTabChange('products')}
                                type="button"
                            >
                                Products
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'loose' ? 'active' : ''}`}
                                onClick={() => handleTabChange('loose')}
                                type="button"
                            >
                                Loose Products
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'variants' ? 'active' : ''}`}
                                onClick={() => handleTabChange('variants')}
                                type="button"
                            >
                                Serial No / Sku Variants
                            </button>
                        </li>
                    </ul>
                    {activeTab === 'products' && (
                        <>
                            <DataTable
                                columns={productsColumn}
                                data={filteredProducts}
                                pagination
                                paginationServer
                                paginationTotalRows={totalCount}
                                paginationPerPage={paginationPerPage}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                highlightOnHover
                                striped
                                dense
                                progressPending={productsLoading}
                                customStyles={customTableStyles}
                            />
                        </>
                    )}
                    {activeTab === 'loose' && (
                        <>
                            <DataTable
                                columns={looseProductsColumn}
                                data={filteredProducts}
                                pagination
                                paginationServer
                                paginationTotalRows={totalCount}
                                paginationPerPage={paginationPerPage}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                highlightOnHover
                                striped
                                dense
                                progressPending={productsLoading}
                                customStyles={customTableStyles}
                            />
                        </>
                    )}
                    {activeTab === 'variants' && (
                        <>
                            {filteredVariants && filteredVariants.length > 0 ? (
                                <>
                                    {/* Batch Print Bar for Variants Tab */}
                                    <div className="d-flex align-items-center mb-3 gap-3 flex-wrap">
                                        <button
                                            className="btn btn-outline-primary"
                                            style={{ minWidth: 120 }}
                                            onClick={() => {
                                                if (checkedVariations.length === filteredVariants.length) {
                                                    setCheckedVariations([]);
                                                    setSerialTags([]);
                                                } else {
                                                    const productGroups = {};
                                                    filteredVariants.forEach(v => {
                                                        const pid = v.product?.id;
                                                        if (!productGroups[pid]) productGroups[pid] = [];
                                                        productGroups[pid].push(v.id);
                                                    });
                                                    const allIds = Object.values(productGroups).flat();
                                                    setCheckedVariations(allIds);
                                                    const allSerials = filteredVariants.filter(v => v.serial_no).map(v => v.serial_no);
                                                    setSerialTags(allSerials);
                                                }
                                            }}
                                        >
                                            {checkedVariations.length === filteredVariants.length ? 'Uncheck All' : 'Check All'}
                                        </button>
                                        <div className="input-group" style={{ maxWidth: 220 }}>
                                            <span className="input-group-text">Barcode</span>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => setBarcodeCount(bc => Math.max(1, bc - 1))}
                                                disabled={barcodeCount <= 1}
                                            >-</button>
                                            <span className="form-control text-center" style={{ pointerEvents: 'none' }}>{barcodeCount}</span>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => setBarcodeCount(bc => Math.min(5, bc + 1))}
                                                disabled={barcodeCount >= 5}
                                            >+</button>
                                        </div>
                                        <div className="input-group" style={{ maxWidth: 220 }}>
                                            <span className="input-group-text">Label</span>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => setLabelCount(lc => Math.max(1, lc - 1))}
                                                disabled={labelCount <= 1}
                                            >-</button>
                                            <span className="form-control text-center" style={{ pointerEvents: 'none' }}>{labelCount}</span>
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => setLabelCount(lc => Math.min(5, lc + 1))}
                                                disabled={labelCount >= 5}
                                            >+</button>
                                        </div>
                                        <button
                                            className="btn btn-success"
                                            disabled={checkedVariations.length === 0}
                                            onClick={handlePrintSelectedSafe}
                                        >
                                            Print Selected
                                        </button>
                                    </div>
                                    {/* Serial Tag Input for Variants Tab */}
                                    <div className="position-relative mt-3 mb-2">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Serial No. (Enter or comma to add, click tag to remove)
                                        </span>
                                        <div className="d-flex flex-wrap gap-2 mb-1">
                                            {serialTags.map(tag => (
                                                <span key={tag} className="badge bg-primary" style={{ cursor: 'pointer' }} onClick={() => handleRemoveSerialTag(tag)}>{tag} &times;</span>
                                            ))}
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Type serial no. and press Enter or comma..."
                                            onKeyDown={handleSerialTagInputAllVariants}
                                        />
                                    </div>
                                    {/* Filter Section for Variants Tab */}
                                    <div className="row g-2 align-items-end mb-3">
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Product Name
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Product Name"
                                                    value={searchProductName}
                                                    onChange={e => setSearchProductName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    SKU
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="SKU"
                                                    value={searchSku}
                                                    onChange={e => setSearchSku(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Barcode
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Barcode"
                                                    value={searchBarcode}
                                                    onChange={e => setSearchBarcode(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Serial No
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Serial No"
                                                    value={searchSerialNo}
                                                    onChange={e => setSearchSerialNo(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Size
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Size"
                                                    value={searchSize}
                                                    onChange={e => setSearchSize(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="position-relative">
                                                <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                                    Color
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Color"
                                                    value={searchColor}
                                                    onChange={e => setSearchColor(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable
                                        columns={variationsColumns}
                                        data={filteredVariants}
                                        pagination
                                        highlightOnHover
                                        striped
                                        dense
                                        customStyles={customTableStyles}
                                    />
                                </>
                            ) : (
                                <p>No Variants Found</p>
                            )}
                        </>
                    )}
                </div>
            </div>

            <AddPurchases show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedProduct} onSubmit={handleFormSubmit} categories={rawCategories} />

            {showVariationModal && (
                <Modal show={showVariationModal} onClose={handleCloseVariationModal} heading={`Product Variations - ${variationListProduct?.name || ''}`} size="xl">
                    {variationListProduct && (
                        <div className="d-flex align-items-center justify-content-between p-2.5 mb-3 bg-light rounded-3 border">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span className="badge bg-primary fs-13 px-2.5 py-1.5">Product</span>
                                <span className="fw-bold text-dark fs-16">{variationListProduct?.name}</span>
                                {variationListProduct?.sku && <span className="text-muted small fw-semibold">SKU: {variationListProduct.sku}</span>}
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {variationListProduct?.Brand?.name && (
                                    <span className="badge bg-secondary-subtle text-secondary border">{variationListProduct.Brand.name}</span>
                                )}
                                {variationListProduct?.product_contain_type && (
                                    <span className="badge bg-info-subtle text-info border">{variationListProduct.product_contain_type}</span>
                                )}
                            </div>
                        </div>
                    )}
                    <div className="d-flex align-items-center mb-3 gap-3">
                        <button
                            className="btn btn-outline-primary"
                            style={{ minWidth: 120 }}
                            onClick={() => {
                                if (checkedVariations.length === filteredVariations.length) {
                                    setCheckedVariations([]);
                                    setSerialTags([]);
                                } else {
                                    const allIds = filteredVariations.map(v => v.id);
                                    setCheckedVariations(allIds);
                                    const allSerials = filteredVariations.filter(v => v.serial_no).map(v => v.serial_no);
                                    setSerialTags(allSerials);
                                }
                            }}
                        >
                            {checkedVariations.length === filteredVariations.length ? 'Uncheck All' : 'Check All'}
                        </button>
                        <div className="input-group" style={{ maxWidth: 220 }}>
                            <span className="input-group-text">Barcode</span>
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => setBarcodeCount(bc => Math.max(1, bc - 1))}
                                disabled={barcodeCount <= 1}
                            >-</button>
                            <span className="form-control text-center" style={{ pointerEvents: 'none' }}>{barcodeCount}</span>
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => setBarcodeCount(bc => Math.min(5, bc + 1))}
                                disabled={barcodeCount >= 5}
                            >+</button>
                        </div>
                        <div className="input-group" style={{ maxWidth: 220 }}>
                            <span className="input-group-text">Label</span>
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => setLabelCount(lc => Math.max(1, lc - 1))}
                                disabled={labelCount <= 1}
                            >-</button>
                            <span className="form-control text-center" style={{ pointerEvents: 'none' }}>{labelCount}</span>
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => setLabelCount(lc => Math.min(5, lc + 1))}
                                disabled={labelCount >= 5}
                            >+</button>
                        </div>
                        <button
                            className="btn btn-success"
                            disabled={checkedVariations.length === 0}
                            onClick={handlePrintSelected}
                        >
                            Print Selected
                        </button>
                    </div>
                    <div className="mb-2">
                        <label className="form-label">Serial No. (Enter or comma to add, click tag to remove)</label>
                        <div className="d-flex flex-wrap gap-2 mb-1">
                            {serialTags.map(tag => (
                                <span key={tag} className="badge bg-primary" style={{ cursor: 'pointer' }} onClick={() => handleRemoveSerialTag(tag)}>{tag} &times;</span>
                            ))}
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Type serial no. and press Enter or comma..."
                            onKeyDown={handleSerialTagInput}
                        />
                    </div>
                    <div className="mb-3">
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by variation name, barcode, or serial number..."
                                value={variationSearchTerm}
                                onChange={(e) => setVariationSearchTerm(e.target.value)}
                            />
                            {variationSearchTerm && (
                                <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={() => setVariationSearchTerm('')}
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            )}
                        </div>
                    </div>

                    <div style={{ maxHeight: '80vh', overflow: 'scroll' }}>
                        <DataTable
                            columns={variationsColumns}
                            data={filteredVariations}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            highlightOnHover
                            striped
                            dense
                            responsive
                            noDataComponent={
                                variationSearchTerm ?
                                    `No variations found matching "${variationSearchTerm}"` :
                                    "No variations found"
                            }
                            customStyles={customTableStyles}
                        />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="text-muted small">
                            Showing {filteredVariations.length} of {variationEdit.length} variations
                        </div>
                        <div>
                            <button className="btn btn-secondary me-2" onClick={handleCloseVariationModal}>Close</button>
                            <button className="btn btn-primary" onClick={handleSaveVariations}>Save</button>
                        </div>
                    </div>
                </Modal>
            )}

            {showVariationModalGrouped && (
                <Modal show={showVariationModalGrouped} onClose={handleCloseVariationModalGrouped} heading={`Product Variations Grouped - ${variationListProduct?.name || ''}`} size="lg">
                    {variationListProduct && (
                        <div className="d-flex align-items-center justify-content-between p-2.5 mb-3 bg-light rounded-3 border">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span className="badge bg-primary fs-13 px-2.5 py-1.5">Product</span>
                                <span className="fw-bold text-dark fs-16">{variationListProduct?.name}</span>
                                {variationListProduct?.sku && <span className="text-muted small fw-semibold">SKU: {variationListProduct.sku}</span>}
                            </div>
                        </div>
                    )}
                    <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
                        {groupedVariations.map(group => {
                            const idealStocks = variationListProduct?.idealStocks || group.items[0]?.product?.idealStocks;
                            const idealRecord = findIdealStockRecord(idealStocks, group.variant_name);
                            const idealQty = idealRecord ? (parseFloat(idealRecord.ideal_stock) || 0) : 0;
                            const idealWholesale = idealRecord ? (parseFloat(idealRecord.wholesale_ideal_stock) || 0) : 0;
                            const totalRetail = group.items.reduce((s, it) => s + (Number(it.qty) || 0), 0);
                            const totalWholesale = group.items.reduce((s, it) => s + (Number(it.current_wholesale) || 0), 0);
                            const totalStock = totalRetail + totalWholesale;

                            return (
                                <div key={group.variant_name} className="mb-3 border rounded p-3 bg-light shadow-sm">
                                    <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                                        <h6 className="mb-0 fs-17 fw-bold text-dark">{group.variant_name.replace(/-+$/, '')}</h6>
                                        <div className="d-flex flex-wrap gap-2">
                                            <span className="badge bg-success fs-14 py-2 px-3">Ideal Retail: {idealQty}</span>
                                            <span className="badge bg-primary fs-14 py-2 px-3">Current Retail: {totalRetail}</span>
                                            <span className="badge bg-info text-white fs-14 py-2 px-3">Ideal Wholesale: {idealWholesale}</span>
                                            <span className="badge bg-warning text-dark fs-14 py-2 px-3">Current Wholesale: {totalWholesale}</span>
                                            <span className="badge bg-dark text-white fs-14 py-2 px-3">Total Stock: {totalStock}</span>
                                        </div>
                                    </div>
                                    {group.items.some(item => item.serial_no) && (
                                        <div className="d-flex flex-wrap gap-2 mt-2 pt-2 border-top">
                                            {group.items.filter(item => item.serial_no).map((item, idx) => (
                                                <span key={item.id || idx} className="badge bg-secondary">
                                                    {item.serial_no}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <button className="btn btn-secondary me-2" onClick={handleCloseVariationModalGrouped}>Close</button>
                        </div>
                    </div>
                </Modal>
            )}

            {showAvailableVariantsModal && selectedProductForVariants && (
                <Modal show={showAvailableVariantsModal} onClose={() => setShowAvailableVariantsModal(false)} heading={`Available Variants - ${selectedProductForVariants?.name || ''}`} size="lg">
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeVariantTab === 'potency' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveVariantTab('potency');
                                    setSelectedPotency(null);
                                    setSelectedVolume(null);
                                }}
                            >
                                Potency
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeVariantTab === 'volume' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveVariantTab('volume');
                                    setSelectedPotency(null);
                                    setSelectedVolume(null);
                                }}
                            >
                                Volume
                            </button>
                        </li>
                    </ul>

                    <div className="row">
                        <div className="col-md-4">
                            <h6>{activeVariantTab === 'potency' ? 'Potencies' : 'Volumes'}</h6>
                            <div className="list-group" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {activeVariantTab === 'potency' ? (
                                    [...new Set(selectedProductForVariants.AvailableVariants.map(v => v.potency))].map(potency => (
                                        <button
                                            key={potency}
                                            type="button"
                                            className={`list-group-item list-group-item-action ${selectedPotency === potency ? 'active' : ''}`}
                                            onClick={() => {
                                                setSelectedPotency(potency);
                                                setSelectedVolume(null);
                                            }}
                                        >
                                            {potency}
                                        </button>
                                    ))
                                ) : (
                                    [...new Set(selectedProductForVariants.AvailableVariants.map(v => v.volume))].map(volume => (
                                        <button
                                            key={volume}
                                            type="button"
                                            className={`list-group-item list-group-item-action ${selectedVolume === volume ? 'active' : ''}`}
                                            onClick={() => {
                                                setSelectedVolume(volume);
                                                setSelectedPotency(null);
                                            }}
                                        >
                                            {volume}
                                        </button>
                                    ))
                                )}
                            </div>
                        </div>
                        <div className="col-md-8">
                            <h6>{activeVariantTab === 'potency' ? (selectedPotency ? `Volumes for Potency: ${selectedPotency}` : 'Select a Potency') : (selectedVolume ? `Potencies for Volume: ${selectedVolume}` : 'Select a Volume')}</h6>
                            {activeVariantTab === 'potency' && selectedPotency ? (
                                <div className="d-flex flex-wrap gap-2">
                                    {selectedProductForVariants.AvailableVariants
                                        .filter(v => v.potency === selectedPotency)
                                        .map(v => (
                                            <span key={v.id} className="badge bg-primary" style={{ padding: '8px 12px', fontSize: '14px' }}>
                                                {v.volume}
                                            </span>
                                        ))}
                                </div>
                            ) : activeVariantTab === 'volume' && selectedVolume ? (
                                <div className="d-flex flex-wrap gap-2">
                                    {selectedProductForVariants.AvailableVariants
                                        .filter(v => v.volume === selectedVolume)
                                        .map(v => (
                                            <span key={v.id} className="badge bg-success" style={{ padding: '8px 12px', fontSize: '14px' }}>
                                                {v.potency}
                                            </span>
                                        ))}
                                </div>
                            ) : (
                                <p className="text-muted">Select an item from the left to view details.</p>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-secondary" onClick={() => setShowAvailableVariantsModal(false)}>Close</button>
                    </div>
                </Modal>
            )}

            {showLooseModal && selectedVariationForLoose && (
                <Modal show={showLooseModal} onClose={() => setShowLooseModal(false)} heading={`Transfer to JNM LOOSE - ${selectedVariationForLoose.variant_name || ''}`} size="md">
                    <div className="p-3">
                        <div className="alert alert-info py-2 mb-3">
                            <div className="small"><strong>Source Product:</strong> {selectedVariationForLoose.product?.name || variationListProduct?.name || ''}</div>
                            <div className="small"><strong>Target Brand:</strong> <span className="badge bg-primary">JNM LOOSE</span></div>
                        </div>

                        {/* Stock Source Toggle */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Transfer From Stock Type:</label>
                            <div className="d-flex gap-2">
                                <button
                                    type="button"
                                    className={`btn flex-fill d-flex flex-column align-items-center py-2 ${looseStockSource === 'retail' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => setLooseStockSource('retail')}
                                >
                                    <span className="small">Retail Stock</span>
                                    <strong className="fs-15">{selectedVariationForLoose.qty || 0}</strong>
                                </button>
                                <button
                                    type="button"
                                    className={`btn flex-fill d-flex flex-column align-items-center py-2 ${looseStockSource === 'wholesale' ? 'btn-success' : 'btn-outline-secondary'}`}
                                    onClick={() => setLooseStockSource('wholesale')}
                                >
                                    <span className="small">Wholesale Stock</span>
                                    <strong className="fs-15">{selectedVariationForLoose.current_wholesale || 0}</strong>
                                </button>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                Quantity of Units to Move ({looseStockSource === 'wholesale' ? 'Wholesale' : 'Retail'} Available: {looseStockSource === 'wholesale' ? (selectedVariationForLoose.current_wholesale || 0) : (selectedVariationForLoose.qty || 0)})
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                value={looseQtyInput}
                                onChange={(e) => handleLooseQtyChange(e.target.value)}
                                placeholder="Enter units to move..."
                                min="1"
                                max={looseStockSource === 'wholesale' ? (selectedVariationForLoose.current_wholesale || 0) : (selectedVariationForLoose.qty || 0)}
                                step="1"
                            />
                            <small className="text-muted">This will be deducted from this product's {looseStockSource} stock.</small>
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Loose Volume to Add (ml / gm)</label>
                            <input
                                type="number"
                                className="form-control"
                                value={looseVolumeInput}
                                onChange={(e) => setLooseVolumeInput(e.target.value)}
                                placeholder="Enter loose volume to add..."
                                step="0.01"
                            />
                            <small className="text-muted">This loose quantity will be added to the matching <strong>JNM LOOSE</strong> brand product.</small>
                        </div>
                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary" onClick={() => setShowLooseModal(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={handleLooseSubmit}>
                                <ArrowLeftRight size={16} className="me-1" />
                                Transfer from {looseStockSource === 'wholesale' ? 'Wholesale' : 'Retail'} to JNM LOOSE
                            </button>
                        </div>
                    </div>
                </Modal>
            )}

            {showTransferModal && selectedVariationForTransfer && (
                <Modal show={showTransferModal} onClose={() => setShowTransferModal(false)} heading={`Transfer Stock - ${selectedVariationForTransfer.variant_name || ''}`} size="md">
                    <div className="p-3">
                        <div className="d-flex gap-2 mb-3">
                            <button
                                className={`btn flex-fill ${transferDirection === 'wholesale_to_retail' ? 'btn-success' : 'btn-outline-success'}`}
                                onClick={() => setTransferDirection('wholesale_to_retail')}
                            >
                                Wholesale → Retail
                            </button>
                            <button
                                className={`btn flex-fill ${transferDirection === 'retail_to_wholesale' ? 'btn-warning' : 'btn-outline-warning'}`}
                                onClick={() => setTransferDirection('retail_to_wholesale')}
                            >
                                Retail → Wholesale
                            </button>
                        </div>
                        <div className="row mb-3">
                            <div className="col-6">
                                <div className="card text-center bg-light">
                                    <div className="card-body py-2">
                                        <small className="text-muted">Current Retail (qty)</small>
                                        <h5 className="mb-0 text-primary">{selectedVariationForTransfer.qty || 0}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="card text-center bg-light">
                                    <div className="card-body py-2">
                                        <small className="text-muted">Current Wholesale</small>
                                        <h5 className="mb-0 text-success">{selectedVariationForTransfer.current_wholesale || 0}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                {transferDirection === 'wholesale_to_retail'
                                    ? `Quantity to move from Wholesale to Retail (Max: ${selectedVariationForTransfer.current_wholesale || 0})`
                                    : `Quantity to move from Retail to Wholesale (Max: ${selectedVariationForTransfer.qty || 0})`
                                }
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                value={transferQtyInput}
                                onChange={(e) => setTransferQtyInput(e.target.value)}
                                placeholder="Enter quantity to transfer..."
                                step="1"
                                min="1"
                                max={transferDirection === 'wholesale_to_retail'
                                    ? selectedVariationForTransfer.current_wholesale || 0
                                    : selectedVariationForTransfer.qty || 0
                                }
                            />
                        </div>
                        {transferQtyInput && parseFloat(transferQtyInput) > 0 && (
                            <div className="alert alert-info py-2 mb-3">
                                <strong>Preview:</strong>
                                {transferDirection === 'wholesale_to_retail' ? (
                                    <>
                                        {' '}Wholesale: {selectedVariationForTransfer.current_wholesale || 0} → {(parseFloat(selectedVariationForTransfer.current_wholesale) || 0) - parseFloat(transferQtyInput)}
                                        {' | '}Retail: {selectedVariationForTransfer.qty || 0} → {(parseFloat(selectedVariationForTransfer.qty) || 0) + parseFloat(transferQtyInput)}
                                    </>
                                ) : (
                                    <>
                                        {' '}Retail: {selectedVariationForTransfer.qty || 0} → {(parseFloat(selectedVariationForTransfer.qty) || 0) - parseFloat(transferQtyInput)}
                                        {' | '}Wholesale: {selectedVariationForTransfer.current_wholesale || 0} → {(parseFloat(selectedVariationForTransfer.current_wholesale) || 0) + parseFloat(transferQtyInput)}
                                    </>
                                )}
                            </div>
                        )}
                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary" onClick={() => setShowTransferModal(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={handleTransferSubmit}>
                                <ArrowLeftRight size={16} className="me-1" />
                                Confirm Transfer
                            </button>
                        </div>
                    </div>
                </Modal>
            )}

            {showAddStockModal && selectedProductForStock && (
                <Modal
                    show={showAddStockModal}
                    onClose={() => setShowAddStockModal(false)}
                    heading={`Add Stock - ${selectedProductForStock?.name || ''}`}
                    size="lg"
                >
                    <form onSubmit={handleAddStockSubmit} className="p-3">
                        {/* Product Summary Header */}
                        <div className="alert alert-light border d-flex justify-content-between align-items-center py-2 px-3 mb-3">
                            <div>
                                <span className="fw-bold fs-15 text-primary">{selectedProductForStock.name}</span>
                                {selectedProductForStock.sku && (
                                    <span className="badge bg-light text-muted border ms-2">SKU: {selectedProductForStock.sku}</span>
                                )}
                                <div className="small text-muted mt-1">
                                    <span>Brand: <strong>{selectedProductForStock?.Brand?.name || 'OTHER'}</strong></span>
                                    <span className="ms-3">Category: <strong>{selectedProductForStock?.RawCategory?.name || 'General'}</strong></span>
                                </div>
                            </div>
                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 fs-12 fw-bold">
                                Current Stock: 0
                            </span>
                        </div>

                        {/* Variant / Variation Selector */}
                        <div className="card mb-3 border">
                            <div className="card-header bg-light py-2">
                                <h6 className="mb-0 fs-13 fw-bold text-dark">1. Select or Create Variation</h6>
                            </div>
                            <div className="card-body py-2">
                                {Array.isArray(selectedProductForStock?.variations) && selectedProductForStock.variations.length > 0 ? (
                                    <div>
                                        <div className="d-flex gap-2 mb-2">
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${!stockForm.is_new_variant ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handleVariationSelectForStock(selectedProductForStock.variations[0]?.id)}
                                            >
                                                Existing Variations ({selectedProductForStock.variations.length})
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${stockForm.is_new_variant ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handleVariationSelectForStock('new')}
                                            >
                                                + New Variant
                                            </button>
                                        </div>

                                        {!stockForm.is_new_variant ? (
                                            <div>
                                                <label className="form-label fs-12 text-muted mb-1">Choose Variation:</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={stockForm.variation_id}
                                                    onChange={e => handleVariationSelectForStock(e.target.value)}
                                                >
                                                    {selectedProductForStock.variations.map(v => (
                                                        <option key={v.id} value={v.id}>
                                                            {v.variant_name} (Retail: {v.qty || 0}, Wholesale: {v.current_wholesale || 0} | Retail ₹{v.price || 0}, Wholesale ₹{v.wholesale_price || 0})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        ) : (
                                            <div>
                                                <label className="form-label fs-12 text-muted mb-1">New Variant Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="e.g. 30 CH, 200 CH, 100ml, Q-20ML..."
                                                    value={stockForm.variant_name}
                                                    onChange={e => setStockForm(prev => ({ ...prev, variant_name: e.target.value }))}
                                                    required
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        {Array.isArray(selectedProductForStock?.AvailableVariants) && selectedProductForStock.AvailableVariants.length > 0 ? (
                                            <div>
                                                <label className="form-label fs-12 text-muted mb-1">Select from Available Variants or Enter Custom Name:</label>
                                                <div className="d-flex flex-wrap gap-1 mb-2">
                                                    {selectedProductForStock.AvailableVariants.slice(0, 10).map((av, idx) => {
                                                        const avName = `${av.potency || ''} ${av.volume || ''}`.trim();
                                                        return (
                                                            <button
                                                                key={idx}
                                                                type="button"
                                                                className={`badge border ${stockForm.variant_name === avName ? 'bg-primary text-white' : 'bg-light text-dark'}`}
                                                                style={{ cursor: 'pointer', padding: '6px 10px' }}
                                                                onClick={() => setStockForm(prev => ({ ...prev, variant_name: avName }))}
                                                            >
                                                                {avName}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Variant Name (e.g. 30 CH, 100ml...)"
                                                    value={stockForm.variant_name}
                                                    onChange={e => setStockForm(prev => ({ ...prev, variant_name: e.target.value }))}
                                                    required
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <label className="form-label fs-12 text-muted mb-1">Variant Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="e.g. Standard, 30ml, 100ml..."
                                                    value={stockForm.variant_name}
                                                    onChange={e => setStockForm(prev => ({ ...prev, variant_name: e.target.value }))}
                                                    required
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Stock Destination Type */}
                        <div className="card mb-3 border">
                            <div className="card-header bg-light py-2">
                                <h6 className="mb-0 fs-13 fw-bold text-dark">2. Stock Destination Type</h6>
                            </div>
                            <div className="card-body py-2">
                                <div className="btn-group w-100" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${stockForm.stock_type === 'wholesale' ? 'btn-success fw-bold' : 'btn-outline-success'}`}
                                        onClick={() => setStockForm(prev => ({ ...prev, stock_type: 'wholesale' }))}
                                    >
                                        🏢 Wholesale Stock
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${stockForm.stock_type === 'retail' ? 'btn-primary fw-bold' : 'btn-outline-primary'}`}
                                        onClick={() => setStockForm(prev => ({ ...prev, stock_type: 'retail' }))}
                                    >
                                        🛒 Retail Stock
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${stockForm.stock_type === 'both' ? 'btn-info text-white fw-bold' : 'btn-outline-info'}`}
                                        onClick={() => setStockForm(prev => ({ ...prev, stock_type: 'both' }))}
                                    >
                                        📦 Both (Wholesale & Retail)
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Quantity and Pricing Inputs */}
                        <div className="card mb-3 border">
                            <div className="card-header bg-light py-2">
                                <h6 className="mb-0 fs-13 fw-bold text-dark">3. Quantity & Price</h6>
                            </div>
                            <div className="card-body py-2">
                                <div className="row g-2">
                                    {(stockForm.stock_type === 'wholesale' || stockForm.stock_type === 'both') && (
                                        <>
                                            <div className="col-md-6">
                                                <label className="form-label fs-12 fw-semibold text-success">
                                                    Wholesale Quantity *
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter wholesale qty..."
                                                    min="1"
                                                    step="1"
                                                    value={stockForm.current_wholesale}
                                                    onChange={e => setStockForm(prev => ({ ...prev, current_wholesale: e.target.value }))}
                                                    required={stockForm.stock_type === 'wholesale'}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-12 fw-semibold text-success">
                                                    Wholesale Price (₹) *
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    placeholder="Wholesale price per unit..."
                                                    min="0"
                                                    step="0.01"
                                                    value={stockForm.wholesale_price}
                                                    onChange={e => setStockForm(prev => ({ ...prev, wholesale_price: e.target.value }))}
                                                    required={stockForm.stock_type === 'wholesale'}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {(stockForm.stock_type === 'retail' || stockForm.stock_type === 'both') && (
                                        <>
                                            <div className="col-md-6">
                                                <label className="form-label fs-12 fw-semibold text-primary">
                                                    Retail Quantity *
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter retail qty..."
                                                    min="1"
                                                    step="1"
                                                    value={stockForm.qty}
                                                    onChange={e => setStockForm(prev => ({ ...prev, qty: e.target.value }))}
                                                    required={stockForm.stock_type === 'retail'}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-12 fw-semibold text-primary">
                                                    Retail Price / MRP (₹) *
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    placeholder="Retail price / MRP per unit..."
                                                    min="0"
                                                    step="0.01"
                                                    value={stockForm.price}
                                                    onChange={e => setStockForm(prev => ({ ...prev, price: e.target.value }))}
                                                    required={stockForm.stock_type === 'retail'}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {/* Cross price when single type selected */}
                                    {stockForm.stock_type === 'wholesale' && (
                                        <div className="col-md-6 mt-2">
                                            <label className="form-label fs-12 text-muted">
                                                Retail Price / MRP (₹) (Optional)
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                placeholder="Retail price..."
                                                min="0"
                                                step="0.01"
                                                value={stockForm.price}
                                                onChange={e => setStockForm(prev => ({ ...prev, price: e.target.value }))}
                                            />
                                        </div>
                                    )}
                                    {stockForm.stock_type === 'retail' && (
                                        <div className="col-md-6 mt-2">
                                            <label className="form-label fs-12 text-muted">
                                                Wholesale Price (₹) (Optional)
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                placeholder="Wholesale price..."
                                                min="0"
                                                step="0.01"
                                                value={stockForm.wholesale_price}
                                                onChange={e => setStockForm(prev => ({ ...prev, wholesale_price: e.target.value }))}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Optional Batch and Expiry */}
                        <div className="row g-2 mb-3">
                            <div className="col-md-6">
                                <label className="form-label fs-12 text-muted mb-1">Batch Number (Optional)</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="e.g. BATCH-2026-01"
                                    value={stockForm.batch_no}
                                    onChange={e => setStockForm(prev => ({ ...prev, batch_no: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fs-12 text-muted mb-1">Expiry Date (Optional)</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={stockForm.exp_date}
                                    onChange={e => setStockForm(prev => ({ ...prev, exp_date: e.target.value }))}
                                />
                            </div>
                        </div>

                        {/* Footer buttons */}
                        <div className="d-flex justify-content-end gap-2 mt-3 pt-2 border-top">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setShowAddStockModal(false)}
                                disabled={isSubmittingStock}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmittingStock}
                            >
                                {isSubmittingStock ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                        Adding Stock...
                                    </>
                                ) : (
                                    <>
                                        <Plus size={16} className="me-1" />
                                        Add Stock
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal>
            )}
        </>
    );
}

export default Products;
